/**
 * Javascript file for the login page.
 * @author Adrian Rebmann, Andrea Villeda
 */

import auth from "../../../../auth";
import { resetPasswordForUser } from "../../../../api";
import { required, email, minLength } from "vuelidate/lib/validators";

export default {
  name: "Signin",

  /**
   * The vue instance's data object.
   * @property {boolean} nosuchuser - Non-existence of the username. 
   * @property {boolean} error - There has been an error.
   * @property {boolean} active - Activate the "forgot your password" view.
   * @property {string} form.email - The entered user email.
   * @property {string} form.password - The entered user password.
   * @property {string} forgotPassMail - The email the password reset should be sent to.
   * @property {boolean} loggedIn - Status of the user's login. 
   * @property {boolean} sending - Information is currently being processed.
   */
  data() {
    return {
      active: false,
      form: {
        email: "",
        password: ""
      },
      forgotPassMail: "",
      loggedIn: false,
      sending: false
    };
  },

  /**
   * Validation to be done to the data.
   * @property {string} form.email - the entered email.
   * @property {string} form.pasword - the entered password.
   */
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required,
        minLength: minLength(8)
      }
    }
  },

  /**
   * The vue instance's method declaration.
   */
  methods: {
    /**
     * Determines if the field is valid or not.
     * @param {string} fieldName - The name of the field.
     */
    getValidationClass(fieldName) {
      const field = this.$v.form[fieldName];
      if (field) {
        return {
          "md-invalid": field.$invalid && field.$dirty
        };
      }
    },

    /**
     * Resets the form.
     */
    clearForm() {
      this.$v.$reset();
      this.form.email = null;
      this.form.password = null;
    },

    /**
     * Logs the user in. 
     * If the login was unsuccessful, it throws an error. 
     * Else, it redirects to the welcome page.
     */
    login() {
      this.sending = true;
      auth.login(this.form.email, this.form.password)
        .then(res => {
          this.sending = false;
          this.$router.replace(this.$route.query.redirect || "/");
        })
        .catch(err => {
          this.sending = false;
          console.error(err);
        })
    },

    /**
     * Validates the entered username. If it's valid, it logs the user in. 
     */
    validateUser() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.login();
      }
    },

    /**
     * Validates the username.
     * This function is empty at the moment.
     */
    validateUsername() { },

    /**
     * The user confirmed the request for a password reset.
     */
    onConfirm() {
      resetPasswordForUser(this.forgotPassMail).then(res => {
        this.$router.replace(this.$route.query.redirect || "/");
      })
    },

    /**
     * The user cancelled the request for a password request. 
     */
    onCancel() { }
  }
};



// WEBPACK FOOTER //
// ./src/components/app/authentication/signin/signin.js